import { formatCnpj } from '@/_helpers/cnpj'
import { Link } from '@tanstack/react-router'
import type { ColumnDef } from '@tanstack/react-table'

import { formatDate } from '../_helpers/date'

const linkToFacilityPage = (companySlug: string, facilitySlug: string) => {
  return `/companies/${companySlug}/facilities/${facilitySlug}/applications`
}

export function getFacilitiesColumns(companySlug: string): ColumnDef<any>[] {
  return [
    {
      accessorKey: 'name',
      header: 'Nome Fantasia',
      cell: ({ row }) => {
        return (
          <Link
            to={linkToFacilityPage(companySlug, row.original.slug) as any}
            className="inline-flex w-full px-8 py-3"
          >
            <span>{row.original.name}</span>
          </Link>
        )
      },
    },
    {
      accessorKey: 'cnpj',
      header: 'CNPJ',
      cell: ({ row }) => {
        return (
          <Link
            to={linkToFacilityPage(companySlug, row.original.slug) as any}
            className="inline-flex w-full px-8 py-3"
          >
            <span>{row.original.cnpj ? formatCnpj(row.original.cnpj) : '—'}</span>
          </Link>
        )
      },
    },
    {
      accessorKey: 'createdAt',
      header: 'Data de Criação',
      cell: ({ row }) => {
        return (
          <Link
            to={linkToFacilityPage(companySlug, row.original.slug) as any}
            className="flex w-full px-8 py-3"
          >
            <span>{row.original.createdAt ? formatDate(row.original.createdAt) : '—'}</span>
          </Link>
        )
      },
    },
  ]
}

/** @deprecated Use getFacilitiesColumns(companySlug) instead */
export const facilitiesColumns = getFacilitiesColumns('')
